import { Component, Input, EventEmitter, Output, OnInit, NgZone } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { ParkbewilligungenData, PbActions } from '../../pages/parkbewilligungen/parkbewilligungen-data';
import { CommonData } from '../../providers/common-data';
import { AdditionalfieldsData } from '../../providers/additionalfields-data';

/**
 * Generated class for the AdditionalvaluesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'additionalvalues',
  templateUrl: 'additionalvalues.html'
})
export class AdditionalvaluesComponent {
  private _table;
  @Input('table') 
  get table(): string {
    return this._table;
  }
  set table(value: string) {
    this._table = value;
    if(this._table && this._recordid){
      this.refreshDetails();
    }    
  }    

  private _recordid;
  @Input('recordid') 
  get recordid(): number {
    return this._recordid;
  }
  set recordid(value: number) {
    this._recordid = value;
    if(this._table && this._recordid){
      this.refreshDetails();
    }    
  }    

  private _readonly = true;
  @Input('readonly') 
  get readonly(): boolean {
    return this._readonly;
  }
  set readonly(value: boolean) {
    this._readonly = "" + value !== "false";
  }    


  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  private additionalvalues;

  constructor(
    public userData: UserData
    ,public pbData: ParkbewilligungenData
    ,public afData: AdditionalfieldsData
    , public common: CommonData
    , public zone: NgZone
  ) 
  {
      this.additionalvalues = [];
  }

  refreshDetails(){      
    //pd.period.edited = "changed";
    console.log("refresh additional values");
    this.zone.run(() => {      
      if(this.additionalvalues){
        this.additionalvalues.length = 0;
      }
      this.afData.loadvalues(this._table, this._recordid).then(res => {
        //console.log(res);
        if(res){
          this.additionalvalues = res;
        }
      });            
    });    
    
  }


  afChanged(event, af,afindex){
/*    
    if(!this.additionalvalues[afindex].edited){
      this.additionalvalues[afindex].edited="changed";
    }

    if(this.onChange){
      this.onChange.emit();
    }
*/    
  }  

  addField(){
/*    
    if(!this.additionalvalues){
      this.additionalvalues = [];
    }
    this.additionalvalues.push({edited:"added", name:"", typ:"text", description:"", required:"1", position:this.additionalvalues.length+1})
    this.afChanged(null, this.additionalvalues[this.additionalvalues.lenght-1], this.additionalvalues.length-1);
  */
  }

  discardChanges(){
    this.refreshDetails();
  }
  updateChanges(){
    /*
    this.afData.updateAdditionalvalues(this._table, this._recordid, this.additionalvalues).then(res => {
      this.additionalvalues = res;
    });        
    */
  }


  validate(){

    return "";

  }
  
}



// WEBPACK FOOTER //
// ./src/components/additionalvalues/additionalvalues.ts